import { Injectable, InjectionToken, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '@scbt-shared/services/auth.service';
import { PERMISSIONS } from '@scb-lib/index';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

export const IS_AUTH_GUARD_DATA_DEF = {
	title: 'Devi essere autenticato',
	message1: null,
	message2: null,
	buttonTrueText: 'ACCEDI',
	buttonFalseText: null,
	redirectToHome: false,
};

export const PERMISSIONS_GUARD = new InjectionToken('PermissionsGuard');

@Injectable()
export class PermissionsGuard {
	private authSrv = inject(AuthService);

	permissionsToChk: PERMISSIONS | Array<PERMISSIONS | PERMISSIONS[]>;

	canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
		this.permissionsToChk = next.data.permissions;
		const res = this.checkCanActivate();
		const logging = res.pipe(tap((b) => console.log('PermissionsGuard:', this.permissionsToChk, b)));
		return logging;
	}

	checkCanActivate(): Observable<boolean> {
		return this.authSrv.listenCheckPermissions(this.permissionsToChk).pipe(take(1));
	}
}
